import * as React from "react";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { formatNumber } from "../services/Utility";
import "../styles/DataTable.css";

export interface Props {
    csvDownloadUrl: string;
    recordCount: number;
}

const DataSummary = ({csvDownloadUrl, recordCount}: Props) => {
  const formattedCount = formatNumber(recordCount);
  return (
    <div className="ds-u-padding--1 table-record-count">
        
        <div className="ds-u-float--right ds-u-valign--bottom screenOnly">
            <a href={csvDownloadUrl} className="ds-c-button ds-c-button--small ds-c-button--transparent">
                <FontAwesomeIcon icon="download" className="ds-u-margin-right--1 ds-u-margin-left--2" />
                Download
            </a>
        </div>
        
        <div>{formattedCount} records returned</div>

    </div>
  );
};

export default DataSummary;